import authAxios from "../../utility/authAxios";
import { API_VERSION, WALLET_SERVICE_PATH } from "../../config/axios";

const API_URI = `${API_VERSION}/${WALLET_SERVICE_PATH}`;

export const getBalance = async (payload = null) => {
    let _payload = {
        type: "cms",
        currency: "BDT",
    };

    if (payload) _payload = { ..._payload, ...payload };
    return authAxios.post(`${API_URI}/wallet/balance`, _payload);
};
